import React, { useState, useEffect } from 'react';
import VignetteBL from './VignetteBL';
import ReactLoading from 'react-loading';

// Inject script to enable video APi
VignetteBL.VignetteVideoApiScriptEnable();

const VignetteArticle = (props) => {
    const { articleId, renderVideo, loaderComponent, videoPosition, articleVersion } = props;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetching the article
        VignetteBL.fetchArticle(articleId, articleVersion, data => {
            VignetteBL.injectArticle(
                'vignette-article-header',
                'vignette-article-body',
                'vignette-video-container',
                data,
                setLoading,
                renderVideo,
                videoPosition,
                injectVideoPositonTopOrBottom
            );
        });

        //Impure function, works on the prop: videoPosition
        function injectVideoPositonTopOrBottom(videoId, videoNode) {
            if (!videoPosition) return;
            VignetteBL.injectVideo(videoId, videoNode);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [articleId]);

    useEffect(() => {
        // Select vignette youtube video
        const targetNode = document.querySelector('body');
        const config = { attributes: true, childList: true, subtree: true };

        // Setting vignette to render iframe videos correctly 
        const callback = function (mutationsList, observer) {
            const $iframeNode = document.querySelector('iframe[src*="youtube"]');

            if ($iframeNode) {
                $iframeNode.parentElement.style.position = "relative";
                $iframeNode.parentElement.style.paddingBottom = "56%";

                return observer.disconnect();
            }

            window.setTimeout(() => {
                return observer.disconnect();
            }, 5000)
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }, [])




    const styles = {
        loaderStyle: {
            width: '130px',
            height: '130px',
            color: '#000000',
            margin: '0 auto'
        }
    }

    return (
        <>
            {loading ?
                loaderComponent || <ReactLoading type={"spinningBubbles"} style={styles.loaderStyle} />
                :
                <section className="vignette-article-container">
                    <div className="vignette-article-header" />

                    {/* Optionally for rendering video on top */}
                    {videoPosition === "top" && <div className="vignette-video-container" />}

                    <div className="vignette-article-body" />

                    {/* Optionally for rendering video on bottom */}
                    {videoPosition === "bottom" && <div className="vignette-video-container" />}
                </section>
            }
        </>
    )
}

export default VignetteArticle
